import { gsap, Back } from 'gsap';
import { IDimOrientation, ResizeHelper } from '../../../core/utils/ResizeHelper';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { TextStyleConfig } from '../../config/translate/TextStyleConfig';
import { GameData } from '../../server/data/GameData';
import { Helper } from '../../../core/utils/Helper';
import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { GameSetting } from '../../../core/setting/GameSetting';
import { SanQuentin2 } from '../../SanQuentin2';
import { PopUpWindow } from './PopUpWindow';
import { SetupJumpingWildSymbol } from './SetupJumpingWildSymbol';
import { BLEND_MODES, Sprite, Text } from 'pixi.js';
import { SpriteButton } from '../splashScreen/modules/SpriteButton';
import { Sequence } from '../../../core/displayobject/Sequence';
import { MathHelper } from '../../../core/utils/MathHelper';
import { SanEngineManager } from '../../engine/SanEngineManager';
import { AnimationEffects } from '../../../core/effects/AnimationEffects';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SanSpineBox } from '../../engine/Symbol/SanSpineBox';

export class SetupAnimationHandler extends PIXI.Container implements StageLayer {


    readonly layoutDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(360, 360)
        }
    };

    _timeLine: gsap.core.Timeline;
    _spineBg: SpinePlayer;

    _jwBox: PIXI.Container;
    _jwXtraVal: PIXI.Sprite;
    _jwStartPos: PIXI.Point[] = [];
    _jwItems: SetupJumpingWildSymbol[] = [];

    _Spins_Cont:PIXI.Container;
    _SpinsTXT_SP: PIXI.Sprite;
    _SpinsTXT_5: Sequence;
    _SpinsTXT_5_gfx: Sequence;
    _SpinsTXT_3: PIXI.Sprite;
    _sparkDrop:Sequence;

    _colletorTxtCont: PIXI.Container;
    _colletorBox: PIXI.Container;

    _spIcon_Gamble: SpriteButton;
    _spIcon_Collect: SpriteButton;

    _jwResult:SpinePlayer;
    _PopTextWindow:PopUpWindow;

    _txtSP: PIXI.Sprite;
    _MaxCapImg: PIXI.Sprite;
    _prevLevel: number = 0;
    _nextLevel: number = 0;

    _redLightShow:SpinePlayer;

    hits: boolean;
    gambleRes: string;
    secondSetup2: boolean = false;
    valueCollects: boolean = false;

    indxClicked: number = -1;
    _skinVal: string;
    _isCapGamble: boolean;
    _isCapGamble_Next: boolean;

    private get distTxtPos():PIXI.Point{
        return ResizeHelper.isLandscape ? new PIXI.Point(0,-310) : new PIXI.Point(0,-430);
    }

    private get jwBoxPos():PIXI.Point{
        if(this.secondSetup2) return ResizeHelper.isLandscape ? new PIXI.Point(380,-230): new PIXI.Point(230,-480);
        else return ResizeHelper.isLandscape ? new PIXI.Point(-215,-210) : new PIXI.Point(-230,-250);
    }

    private get ExtraElements():PIXI.DisplayObject[]{
        return [...this._Spins_Cont.children,this._spIcon_Gamble,this._spIcon_Collect]
    }

    public get setupJWSyms():SetupJumpingWildSymbol[]{
        return this._jwItems;
    }

    private get collectTexts():PIXI.Text[]{
        return this._colletorTxtCont.children as PIXI.Text[];
    }

    private get colletorBox():SanSpineBox[]{
        return this._colletorBox.children as SanSpineBox[];
    }

    constructor(){
        super();
        this.initAnimations();
    }

    protected initAnimations(): void {
        this.sortableChildren = true;

        // BG ----
        this._jwResult = this.addChild(new SpinePlayer("JW"));

        this._jwXtraVal = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("JW_Multiplier/X_2")[0]));
        this._jwXtraVal.anchor.set(0.55, 0.5);
        this._jwXtraVal.scale.set(1.1);
        this._jwXtraVal.alpha = 0;
        this._jwXtraVal.visible = false;

        this._spineBg = this.addChild(new SpinePlayer("fs_door"));

        this._txtSP = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/Block_E")[0]));
        this._txtSP.anchor.set(0.5);
        this._txtSP.alpha = 0;

        this._MaxCapImg = this.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/Max_badge")[0]));
        this._MaxCapImg.anchor.set(0.5);
        this._MaxCapImg.alpha = 0;
        // --------------

        // EXTRAS
        this._Spins_Cont = this.addChild(new PIXI.Container());

        this._SpinsTXT_SP = this._Spins_Cont.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/FreeSpin_Spins_text")[0]));
        this._SpinsTXT_SP.anchor.set(0.5);
        this._SpinsTXT_SP.blendMode = BLEND_MODES.OVERLAY;

        this._SpinsTXT_5 = this._Spins_Cont.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("5Spins_Burn")));
        this._SpinsTXT_5.anchor.set(0.5);
        this._SpinsTXT_5.blendMode = BLEND_MODES.OVERLAY;
        this._SpinsTXT_5.y += this._SpinsTXT_SP.height;

        this._SpinsTXT_5_gfx = this._Spins_Cont.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("5Spins_Burn")));
        this._SpinsTXT_5_gfx.anchor.set(0.5);
        this._SpinsTXT_5_gfx.blendMode = BLEND_MODES.ADD;
        this._SpinsTXT_5_gfx.position =  this._SpinsTXT_5.position;
        this._SpinsTXT_5_gfx.tint = 0xFF0000;
        this._SpinsTXT_5_gfx.visible = false;

        this._SpinsTXT_3 = this._Spins_Cont.addChild(new PIXI.Sprite(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/3_lines")[0]));
        this._SpinsTXT_3.anchor.set(0.5);
        this._SpinsTXT_3.blendMode = BLEND_MODES.OVERLAY;
        this._SpinsTXT_3.y += this._SpinsTXT_SP.height + this._SpinsTXT_5.height/2;

        this._sparkDrop = this.addChild(new Sequence(SanQuentin2.assetLoader.getTextures("doorDropSparks")));
        this._sparkDrop.blendMode = BLEND_MODES.ADD;
        this._sparkDrop.anchor.set(0.5);
        this._sparkDrop.alpha = 0;
        // ---

        // BTN -------

        this._spIcon_Gamble = this.addChild(new SpriteButton(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/Sticker_gamble")[0]));
        this._spIcon_Gamble.SetHoverCB((val:boolean) => this.redColoringHover(val));
        this._spIcon_Gamble.SetPressSound(SoundConfig.SETUP_GAMBLE_CLICK)

        this._spIcon_Collect = this.addChild(new SpriteButton(SanQuentin2.assetLoader.getTextures("fs_door/Javi assets/Sticker_collect")[0]));
        this._spIcon_Collect.SetPressSound(SoundConfig.SETUP_COLLECT_CLICK)

        // JW -------
        this._jwBox = this.addChild(new PIXI.Container());
        this._jwBox.sortableChildren = true;

        for(let i = 0; i < 5; i++){
            const jw = this._jwBox.addChild(new SetupJumpingWildSymbol(i, i > 2)); 
            jw.zIndex = -i;
            this._jwItems.push(jw);
            this._jwStartPos.push(new PIXI.Point(i*60, 30 * (i%2)));
        }
        
        this.resetJWPosAngle2();
        // -------
        this._PopTextWindow = this.addChild(new PopUpWindow());
        this._PopTextWindow.alpha = 0;
        this._PopTextWindow.position.set(-266,-136);

        this.ExtraElements.forEach(d => d.alpha = 0 );

        this._colletorBox = this.addChild(new PIXI.Container());
        this._colletorTxtCont = this.addChild(new PIXI.Container());
        for(let r = 0; r < SanEngineManager.AllReels.length; r++){
            const txt = new PIXI.Text("0",TextStyleConfig.MULTIPLIER_TEXT);
            const spine = new SanSpineBox("hatch");
            txt.alpha = 0;
            txt.anchor.set(0.5);
            spine.scale.set(1,0.8);
            spine.position.y = 2;
            this._colletorBox.addChild(spine);
            this._colletorTxtCont.addChild(txt);
        }

        this._redLightShow = this.addChild(new SpinePlayer("red light"));
        this._redLightShow.zIndex = 500;
        this._redLightShow.alpha = 0;
    }

    resetJWPosAngle2():void{
        this.setupJWSyms.forEach((jw,i) => {
            jw.alpha = 0;
            jw.position = MathHelper.pointAdd(this.jwBoxPos,this._jwStartPos[i]);
            jw.scale.set(.6);
            jw.setActiveSpine(false);
            jw.zIndex = -1;
        });
    }

    setData(data: GameData): void {
        this._nextLevel = data.raw.nextSetupLevel ?? 0;
        this._prevLevel = data.isRestoreState ? this._nextLevel : data.raw.currenSetupLevel ?? 0;

        this._skinVal = data.raw.nextSetupLevel >= 2 ? data.raw.nextSetupLevel == 4 ? "max" : "jw_1_5" : "jw_1_6";
        this._isCapGamble = data.raw.currenSetupLevel == 4;
        this._isCapGamble_Next = this._skinVal == "max";
        this.hits = data.raw.gambleResult == "Passed";
        this.gambleRes = data.raw.gambleResult;
    }

    protected createTextObject(txt:string = "test"):PIXI.Text{
        const textObj = new PIXI.Text(txt,TextStyleConfig.XWAYS_WIN);
        textObj.anchor.set(0.5,0.5);
        this.addChild(textObj);
        return textObj;
    }

    get blockString():string{
        return "Block  " + ["E","D","C","B","A"][Math.min(this._nextLevel, 4)];
    }

    public playIntro(): gsap.core.Timeline {
        this.secondSetup2 = false;
        this.valueCollects = false;
        this._SpinsTXT_5_gfx.visible = false;
        this._SpinsTXT_5_gfx.alpha = 0;
        this.indxClicked = -1;

        this.resetJWPosAngle2();
        this.onResize();
        // this._txtLevel.text = this.blockString;//"District " + ["E","D","C","B","A"][Math.min(this._nextLevel, 4)];
        this.setupJWSyms.forEach((jw,indx) => {
            jw.setActiveSpine(indx <= this._nextLevel)
        })

        this._timeLine = Helper.setTimeline(this._timeLine, {
            onStart: () => { this.visible = true; this._SpinsTXT_5.visible = true; },
            onComplete: ()=> {
                this.onResize();
            }
        });
        const delay:number = 0.25;

        this._timeLine.add(this._spineBg.play({ onStart:() =>this._spineBg.alpha =1, 
            animation:"basegame_to_setup", showOnEnd:true, skinType: this._skinVal
        }),0);
        
        this._timeLine.fromTo([this._spIcon_Collect,this._spIcon_Gamble,this._txtSP],{alpha:0},{alpha:1, duration:0.25 },delay);
        this._timeLine.fromTo(this.ExtraElements,{alpha:0},{alpha:1,duration:delay},delay)

        const toScale = ResizeHelper.isLandscape ? 0.5 :  0.65;

        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.FS_START_INTRO_BADGES);
        },delay);
        
        this.setupJWSyms.forEach((jw,indx) => {
            this._timeLine.fromTo(jw.scale,{x:0.3,y:0.3},{x:toScale,y:toScale,duration:delay,ease: "Bounce.easeOut"},delay + indx*0.1)
            this._timeLine.fromTo(jw,{alpha:0},{alpha: indx <= this._nextLevel ? 1 : 0.6},delay+indx*0.1)
        })

        this._timeLine.fromTo(this._MaxCapImg.scale,{x:0.3,y:0.3},{x:toScale,y:toScale,duration:delay,ease: "Bounce.easeOut"},delay + this.setupJWSyms.length*0.1)
        this._timeLine.fromTo(this._MaxCapImg,{alpha:0},{alpha:1},delay+this.setupJWSyms.length*0.1)

        return this._timeLine;
    }

    public playClickable(onClicked: Function): void {

        if(!GameSetting.replayMode){
             this._spIcon_Gamble.SetInteractive(true,() => {
                this.onPressed(this._spIcon_Gamble,2);
                this._PopTextWindow.show(undefined, () => { onClicked(2); })
            })

            this._spIcon_Collect.SetInteractive(true,() => {
                this.onPressed(this._spIcon_Collect,1);
                this._PopTextWindow.show(undefined, () => { onClicked(1); })
            })
        }
    }

    public restoreClicker(val:number):void{
        const btnClicked = val == 1 ? this._spIcon_Collect : this._spIcon_Gamble;
        this.onPressed(btnClicked, val); 
    }

    ClickedGamble(): gsap.core.Timeline{
        
        this._timeLine = Helper.setTimeline(this._timeLine);
        this._jwXtraVal.visible = this._nextLevel >= 2 && this._nextLevel != 4;

        
        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.SETUP_HATCH_OPEN);
        })
        this._timeLine.add(this._spineBg.play({animation:"slider_open", showOnEnd:true,skinType: this._skinVal,onComplete:() => {
            this._spineBg.play({animation:"slider_loop",loop:true, showOnEnd:true,skinType: this._skinVal});
        }}));
        // /*
        //     "level1",
        //     "level2",
        //     "max"
        // */
        const redVal = this._jwXtraVal.visible ? "level2" : this._isCapGamble_Next ? "max" : "level1";
        this._timeLine.add( () => {
            this._redLightShow.play({animation: redVal,loop:true,showOnEnd:true});
        },0)
        this._timeLine.fromTo(this._redLightShow,{alpha:0},{alpha:1,duration:0.1},0);
        this.redColoringHover(true);

        const showDurr:number = 1;
        this._jwResult.visible = true;
        let scaleTo = 1;
        if(this._isCapGamble_Next){
            this._jwResult.play({animation:"max_loose",freezed:true});
            scaleTo = 0.8;
            this._jwResult.pivot.y = 30;
        }
        else {
            this._jwResult.play({animation:"JW_disactivate",showOnEnd:true});
            this._jwResult.pivot.y = 0;
        }

        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.SETUP_RESULT_SCALING); 
            this._jwResult.zIndex = 1000;
            this._jwXtraVal.zIndex = 1001;
        },0.5)
        this._timeLine.fromTo(this._jwResult,{alpha:0},{alpha:1, duration:showDurr},0.5);
      
        this._timeLine.fromTo(this._jwResult.scale,{x:0.5,y:0.5},{x:scaleTo,y:scaleTo, duration:showDurr},0.5);

        if(this._jwXtraVal.visible){
            this._timeLine.fromTo(this._jwXtraVal,{alpha:0},{alpha:1, duration:showDurr},0.5);
            this._timeLine.fromTo(this._jwXtraVal.scale,{x:0.5,y:0.5},{x:1.1,y:1.1, duration:showDurr},0.5);
        }
        
        return this._timeLine;
    }

    disableClickAble():void{
        this._spIcon_Gamble.SetInteractive(false);
        this._spIcon_Collect.SetInteractive(false);
    }

    public ShowClickResult(): gsap.core.Timeline {

        this._timeLine = Helper.setTimeline(this._timeLine,{onComplete:() => {
            this._redLightShow.stop();
        }});

        const didMiss: boolean = !this.hits || this._prevLevel == this._nextLevel;

        const nextSpineAnim: string = didMiss ? "loose" : this._jwXtraVal.visible ? "JW_activate_x2" : "JW_activate";
        this._timeLine.add(() => {
            SoundManager.playSoundEffect(didMiss ? SoundConfig.SETUP_RESULT_FAIL : SoundConfig.SETUP_RESULT_PASSED);
        });

        if(this._isCapGamble)
            this._timeLine.add(this._jwResult.play({animation:"max_loose",showOnEnd:true}));
        else
            this._timeLine.add(this._jwResult.play({animation:nextSpineAnim, showOnEnd:true}));

        const resDel:number = this._timeLine.totalDuration();
       
        if (!didMiss) {
            this._timeLine.add(() => { 
                this.setupJWSyms[this._nextLevel].setActiveSpine(!didMiss);
                SoundManager.playSoundEffect(SoundConfig.SETUP_RESULT_THUMB);
             }, resDel/2);
            this._timeLine.to(this, { duration: 0.15 }, resDel);

        }else{
            if(this._jwXtraVal.visible){
                this._timeLine.to(this._jwXtraVal,{alpha:0, duration:0.25},0); // hide 5 spins
            }
            this._sparkDrop.position = this._jwResult.position;
            const targetPos = this._jwResult.position.y + 200; 
            
            this._timeLine.add(this._sparkDrop.play({duration:0.5,onStart:() => this._sparkDrop.alpha =1}),0);
            this._timeLine.to(this._sparkDrop,{y:targetPos,duration:0.5},0);
            this._timeLine.to(this._sparkDrop,{alpha:0,duration:0.1},0.4);

            this._timeLine.add(this._SpinsTXT_5.play({onCompleteCallback:() => { this._SpinsTXT_5.visible = false; this._SpinsTXT_5.setFrame(0);} }),0.5)

            this.removeFailedJw();
        }

        this._timeLine.add(() => { 
            this._jwResult.zIndex = -1000;
            this._jwXtraVal.zIndex = -999;
            SoundManager.playSoundEffect(SoundConfig.SETUP_HATCH_CLOSES)
            this._spineBg.play({ animation: "slider_close",skinType: this._skinVal, showOnEnd: true })
         });
        this._spineBg.addSpineDuration(this._timeLine, "slider_close");
        this._timeLine.add(() => { this._jwResult.stop() });
        this._timeLine.fromTo(this._redLightShow,{alpha:1},{alpha:0,duration:this._timeLine.duration()},0)
        return this._timeLine;
    }

    removeFailedJw():void{
        let offset:number = 0;
        const resDel:number = this._timeLine.totalDuration();

        for(let k = this._nextLevel+1; k < this.setupJWSyms.length; k++){
            this._timeLine.add(() => { 
                this.setupJWSyms[k].jwRemoved()
             }, resDel + offset)
            offset += 0.1;
        }
        this._timeLine.to(this._MaxCapImg, { alpha: 0, duration: 0.25 }, resDel + offset);
        this._jwResult.addSpineDuration(this._timeLine, "loose",resDel + offset);
    }

    public NextSetup(): gsap.core.Timeline {
        this._spIcon_Gamble.SetInteractive(false);
        this._spIcon_Collect.SetInteractive(false);
        this.secondSetup2 = true;
        
        this._timeLine = Helper.setTimeline(this._timeLine);

        this.removeFailedJw();

        const delStart:number = this._timeLine.duration()-0.5;

        this._timeLine.to([this._spIcon_Collect, this._spIcon_Gamble], { alpha: 0, duration: 0.25 }, delStart)

        this._timeLine.to(this.ExtraElements, { alpha: 0, duration: 0.25 }, delStart);
        this._timeLine.to(this._jwXtraVal, { alpha: 0, duration: 0.25 }, delStart);
        this.redColoringHover(false);

        this.setupJWSyms.forEach((jw, i) => {
            const startTrigg = delStart + 0.25 + i * .1;
            
            this._timeLine.add(() => {
                if (!jw.removed)
                    SoundManager.playSoundEffect(SoundConfig.SETUP_MINI_MOVING);
            }, startTrigg);

            if(ResizeHelper.isLandscape)
                this._timeLine.to(jw, { duration: 0.5, y: this.jwBoxPos.y + i * 20, x: this.jwBoxPos.x, ease: "Back.easeIn" }, startTrigg);
            else
                this._timeLine.to(jw, { duration: 0.5, y: this.jwBoxPos.y, x: this.jwBoxPos.x + i * 20, ease: "Back.easeIn" }, startTrigg);

            this._timeLine.to(jw.scale, { duration: 0.5, y: 0.5, x: 0.5 }, startTrigg);
            this._timeLine.add(() => { if (!jw.removed) jw.setActiveSpine(true) }, startTrigg + 0.5)
        });

        const delStart2:number = this._timeLine.duration() - 1;
        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.SETUP_NEXT_BURNER);
            this._spineBg.play({ animation: "transform_out", showOnEnd: true, skinType: this._skinVal });
           }, delStart2);

        this._timeLine.to(this,{duration:this._spineBg.fetchDuration("transform_out")-1.4},delStart2)
        // this._spineBg.addSpineDuration(this._timeLine, "transform_out", delStart2);

        const currDurr = this._timeLine.duration();
        this._colletorBox.alpha = 1;
        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.BOX_MULTIES_POP)
        },currDurr)
        
        this.colletorBox.forEach((box,reel) =>{
            this._timeLine.add(box.playShow(),currDurr + Math.abs(reel-2)*0.2);
        })
      
        return this._timeLine;
    }

    showCaseEnableVal(reelID:number,enable:boolean){
        this.collectTexts[reelID].text = "0";
        if(enable) {
            const tl = this.colletorBox[reelID].playExplode();
            tl.to(this.collectTexts[reelID],{alpha: enable ? 1 : 0, duration:0.2},"-=0.2")
        }
    }

    ApplyBottomTextVal(reelID:number,amount:number){
        AnimationEffects.Bounce(this.collectTexts[reelID],1.2)
        this.collectTexts[reelID].text = amount.toString();
    }

    private tlRedHover:gsap.core.Timeline;
    private redColoringHover(onObj:boolean){
        if(this.indxClicked == 2 && !onObj) return;

        this.tlRedHover = Helper.setTimeline(this.tlRedHover);
        this.tlRedHover.to(this._SpinsTXT_5_gfx,{alpha: onObj ? 0.4 : 0, duration:0.1 });
        this._SpinsTXT_5_gfx.visible = true;
    }

    public onGambleCapWon(): gsap.core.Timeline {
        SoundManager.playSoundEffect(SoundConfig.SETUP_RESULT_MAX);
        const tl = this._jwResult.play({
            animation: "max_win", showOnEnd: true, onComplete: () => {
                this._redLightShow.stop();
            }
        });
        tl.to(this._redLightShow, { alpha: 0, duration: tl.totalDuration() }, 0)
        return tl;
    }

    public onGambleOutro(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine);
        this._spineBg.alpha = 0;

        this._timeLine.to([this._MaxCapImg,this._jwResult],{alpha:0,duration:0.01},0);
        this._timeLine.to(this.setupJWSyms,{alpha:0,duration:0.01},0);
        this._timeLine.to(this._txtSP,{alpha:0,duration:0.01},0);
        this._timeLine.to(this.ExtraElements,{alpha:0,duration:0.01},0)
        this._timeLine.to(this._colletorBox,{alpha:0,duration:0.01},0)

        return this._timeLine;
    }

    public removeOverlay(): void {
        gsap.to([this._txtSP,this._colletorBox], {alpha:0, duration:0.25});
    }

    public CollectValue(totVal:number): gsap.core.Timeline {
        this.valueCollects = true;

        this._timeLine = Helper.setTimeline(this._timeLine);

        this.collectTexts.forEach((txt,reel) => {
            this._timeLine.to(txt,{ x: this.collectTexts[2].x,duration:0.5, ease: "Back.easeIn" }, 0);
            if(reel == 2){
                this._timeLine.add(() => { 
                    this.collectTexts[reel].text = totVal.toString();
                    this.collectTexts[reel].scale.set(2);
                    this.collectTexts[reel].alpha = 1;
                    AnimationEffects.Bounce(this.collectTexts[reel],1.2,0.25);
                },0.5)
            }else{
                this._timeLine.add(() => { 
                    this.collectTexts[reel].alpha = 0;
                },0.5)
            }
        })
        this._timeLine.to(this,{duration:0.2});
        this._timeLine.to(this.collectTexts[2], { y:-400, duration:0.75});
        this._timeLine.to(this.collectTexts[2], { alpha:0, duration:0.5});

        return this._timeLine;
    }

    public removeSides(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine);
        SanQuentin2.background.setBgGFX(0,0.25);

        if(this._prevLevel >= 2)
            SanQuentin2.background.showRedLight(true);
        this._timeLine.add(() => {
            SoundManager.playSoundEffect(SoundConfig.SETUP_2_REMOVE_SIDES);
        })
        this._timeLine.add(this._spineBg.play({animation:"setup_to_freespin",skinType: this._skinVal}))
        return this._timeLine;
    }

    private onPressed(obj: SpriteButton,indx:number) {
        this.indxClicked = indx;
        this._PopTextWindow.setTextbyIndx(indx, this._nextLevel+1);

        if(this.indxClicked == 1) this.redColoringHover(false);
        obj.animateClick();
    }

    public onResize(): void {
        this._spineBg.scale = SanQuentin2.reelEngineManager.dim.scale;

        if(ResizeHelper.isLandscape){
            this._spineBg.position.set(0);

            this._Spins_Cont.position.y = 160;
            this._Spins_Cont.scale.set(0.75);

            this._spIcon_Collect.position.set(180,230);
            this._spIcon_Gamble.position.set(-180,230);
            this._MaxCapImg.position.set(150,-202);
            this._MaxCapImg.scale.set(0.5);
            this._PopTextWindow.position.set(-270,-136);

            this._txtSP.scale.set(0.7);
        }else{
            this._spineBg.position.set(6,0);
            this._PopTextWindow.position.set(-266,-136);

            this._Spins_Cont.scale.set(0.9);
            this._Spins_Cont.position.y = 200;

            this._spIcon_Collect.position.set(200,250);
            this._spIcon_Gamble.position.set(-200,250);

            this._MaxCapImg.position.set(150,-240);
            this._MaxCapImg.scale.set(0.65,0.65);

            this._txtSP.scale.set(1);
        }

        this.setupJWSyms.forEach((jw,indx) => {
            if (this.secondSetup2){
                if(ResizeHelper.isLandscape)
                    jw.position = new PIXI.Point( this.jwBoxPos.x, this.jwBoxPos.y + indx * 20);
                else
                    jw.position = new PIXI.Point( this.jwBoxPos.x + indx * 20,this.jwBoxPos.y );
            }
            else
                jw.position = MathHelper.pointAdd(this.jwBoxPos, this._jwStartPos[indx]);
        })

        this._txtSP.position = this.distTxtPos;

        if(!this.secondSetup2)
            this.setupJWSyms.forEach((jw,indx) => {
                jw.scale.set( ResizeHelper.isLandscape ? 0.5 :  0.65);
            })

        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;
        this.position = ResizeHelper.calcDim(this.layoutDim).position;

        if(!ResizeHelper.isLandscape)
            this._colletorTxtCont.position = this._colletorBox.position =  new PIXI.Point(-276,340);
        else
            this._colletorTxtCont.position = this._colletorBox.position = new PIXI.Point(-240,290);

        if(!this.valueCollects){
            this.collectTexts.forEach((txt,reel) => {
                txt.scale.set(1);
                txt.position.x = reel ? (140 * reel)*SanEngineManager.dim.scale.x : 0;
                this.colletorBox[reel].position.x = (reel ? (140 * reel) * SanEngineManager.dim.scale.x : 0) + 2;
                txt.position.y = 0;
            })
        }
    }
}
